module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rw8Nge/tc-custom/9781418573256.jpg?1705239536076",
      "alt": "This image is the cover for the book South Carolina Trivia"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("South Carolina Trivia\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Test your Palmetto State knowledge with this trivia book covering its rich history, geography, sports, culture, notable figures, and more!")]), _c('br'), _c('br'), _vm._v("As one of the original thirteen colonies and the site of the first Civil War battle, South Carolina is a fascinating state, and "), _c('i', [_vm._v("South Carolina Trivia")]), _vm._v(" is full of facts to prove it. This book is the ultimate resource on the who, what, when, where, why, and how of the Palmetto State. "), _c('br'), _c('br'), _vm._v("Filled with curious questions and fascinating answers, "), _c('i', [_vm._v("South Carolina Trivia")]), _vm._v(" will provide hours of entertainment and education. Easily adaptable for use with trivia format games, it focuses on the history, culture, people, and places of California.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Al Menendez, Shirley Menendez\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0